import React from 'react';
import { Card } from 'antd';
import Text from '../Text';
import Avatar from '../Avatar';
import Button from '../Button';
import './PracticeCard.less';

type PracticeType = {
  title?: string;
  image?: string;
  partnerLogo?: string;
  partnerName?: string;
  description?: string;
};
export type { PracticeType };

export type PracticeCardProps = {
  course?: PracticeType;
  buttonText?: string;
  buttonAction?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TPracticeCard: React.FC<PracticeCardProps> = ({
  course,
  buttonText,
  buttonAction,
}) => {
  return (
    <Card className="t-practice-card">
      <Card.Grid
        hoverable={false}
        className="t-practice-card-grid t-practice-card-left"
      >
        <img src={course.image} />
      </Card.Grid>
      <Card.Grid
        hoverable={false}
        className="t-practice-card-grid t-practice-card-right"
      >
        <Text bold level={1}>
          {course.title}
        </Text>
        <div className="t-practice-card-partner">
          <Avatar src={course.partnerLogo} size="xs" />
          <Text bold level={3}>
            {course.partnerName}
          </Text>
        </div>
        <div className="t-practice-card-description">
          <Text level={3} innerText={course.description} />
        </div>
        <Button type="primary" onClick={buttonAction}>
          {buttonText}
        </Button>
      </Card.Grid>
    </Card>
  );
};

export default TPracticeCard;
